/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CampaignNumberGraphData,
  CategorizedLeadData,
  DateRangeInput,
  DateRangeLeadsGranular,
  ErpFilter,
  ErrorResponse,
} from '../models/index';
import {
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataToJSON,
    CategorizedLeadDataFromJSON,
    CategorizedLeadDataToJSON,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
    DateRangeLeadsGranularFromJSON,
    DateRangeLeadsGranularToJSON,
    ErpFilterFromJSON,
    ErpFilterToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/index';

export interface CategoryOverviewRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface DateOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface FiltersRequest {
    projectId: string;
}

export interface VerifiedLeadsInTimeByCampaignRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface VerifiedLeadsInTimeByCategoriesRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

/**
 * 
 */
export class LeadCalculationApi extends runtime.BaseAPI {

    /**
     * Creates request options for categoryOverview without sending the request
     */
    async categoryOverviewRequestOpts(requestParameters: CategoryOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling categoryOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/lead/categoryOverview`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async categoryOverviewRaw(requestParameters: CategoryOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CategorizedLeadData>> {
        const requestOptions = await this.categoryOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CategorizedLeadDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async categoryOverview(requestParameters: CategoryOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CategorizedLeadData> {
        const response = await this.categoryOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dateOverview without sending the request
     */
    async dateOverviewRequestOpts(requestParameters: DateOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dateOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/lead/dateOverview`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dateOverviewRaw(requestParameters: DateOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateRangeLeadsGranular>> {
        const requestOptions = await this.dateOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateRangeLeadsGranularFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dateOverview(requestParameters: DateOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateRangeLeadsGranular> {
        const response = await this.dateOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for filters without sending the request
     */
    async filtersRequestOpts(requestParameters: FiltersRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling filters().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/project/{projectId}/lead/filters`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns filters by project.
     */
    async filtersRaw(requestParameters: FiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Array<string>>>> {
        const requestOptions = await this.filtersRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Returns filters by project.
     */
    async filters(requestParameters: FiltersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Array<string>>> {
        const response = await this.filtersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for verifiedLeadsInTimeByCampaign without sending the request
     */
    async verifiedLeadsInTimeByCampaignRequestOpts(requestParameters: VerifiedLeadsInTimeByCampaignRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling verifiedLeadsInTimeByCampaign().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/lead/verified-leads-in-time-by-campaign`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCampaignRaw(requestParameters: VerifiedLeadsInTimeByCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.verifiedLeadsInTimeByCampaignRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCampaign(requestParameters: VerifiedLeadsInTimeByCampaignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.verifiedLeadsInTimeByCampaignRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for verifiedLeadsInTimeByCategories without sending the request
     */
    async verifiedLeadsInTimeByCategoriesRequestOpts(requestParameters: VerifiedLeadsInTimeByCategoriesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling verifiedLeadsInTimeByCategories().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/lead/verified-leads-in-time-by-categories`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCategoriesRaw(requestParameters: VerifiedLeadsInTimeByCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.verifiedLeadsInTimeByCategoriesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async verifiedLeadsInTimeByCategories(requestParameters: VerifiedLeadsInTimeByCategoriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.verifiedLeadsInTimeByCategoriesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
